// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global setup, in case we forgot to define it for some element. */

* {
  outline-color: var(--default-outline-color);
  outline-offset: var(--default-outline-offset);
  outline-width: var(--default-outline-width);
}

.focus-outline,
.focus-outline-keynav {
  transition: outline var(--default-transition); /* Animate our focus outline. */

  &:focus {
    border-radius: var(--outline, 1px); /* Add rounded corners to the outline. */
    outline: var(--outline, var(--default-outline));
    outline-offset: var(--default-outline-offset);
  }
}

.focus-outline-keynav {
  --outline: var(--is-not-keynav);
}

/*
 * Containers with overflow set to another value than "visible"
 * clip the focus outline. This is a workaround.
 */

.focus-outline-container,
:is(.d-stack-v, .d-stack-h, .d-substack) > .focus-outline-container {
  margin: calc(-1 * var(--default-outline-size)) !important;
  padding: var(--default-outline-size) !important;
}
`, "",{"version":3,"sources":["webpack://./packages/ui/src/focus-outline.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE;EACE,2CAA2C;EAC3C,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;;EAEE,6CAA6C,EAAE,+BAA+B;;EAE9E;IACE,kCAAkC,EAAE,wCAAwC;IAC5E,+CAA+C;IAC/C,6CAA6C;EAC/C;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;EAGE;;AACF;;EAEE,yDAAyD;EACzD,+CAA+C;AACjD","sourcesContent":["/* Global setup, in case we forgot to define it for some element. */\n\n* {\n  outline-color: var(--default-outline-color);\n  outline-offset: var(--default-outline-offset);\n  outline-width: var(--default-outline-width);\n}\n\n.focus-outline,\n.focus-outline-keynav {\n  transition: outline var(--default-transition); /* Animate our focus outline. */\n\n  &:focus {\n    border-radius: var(--outline, 1px); /* Add rounded corners to the outline. */\n    outline: var(--outline, var(--default-outline));\n    outline-offset: var(--default-outline-offset);\n  }\n}\n\n.focus-outline-keynav {\n  --outline: var(--is-not-keynav);\n}\n\n/*\n * Containers with overflow set to another value than \"visible\"\n * clip the focus outline. This is a workaround.\n */\n.focus-outline-container,\n:is(.d-stack-v, .d-stack-h, .d-substack) > .focus-outline-container {\n  margin: calc(-1 * var(--default-outline-size)) !important;\n  padding: var(--default-outline-size) !important;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
